import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/clipboard': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M336 64c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h80c0-35.3 28.7-64 64-64s64 28.7 64 64h80zM192 40c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM336 458v-340c0-3.3-2.7-6-6-6h-42v36c0 6.6-5.4 12-12 12h-168c-6.6 0-12-5.4-12-12v-36h-42c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h276c3.3 0 6-2.7 6-6z'
      }
    ]
  }
})
